// FÜGGŐ hozzárendelés indulás-jelölője a lista státusz-cellájában — minden függő sor kap egyet, hogy a
// számlázás kezdete a figyelő ablakán kívül is látsszon (user-kérés). Négy állapot:
// nincs számlázás-kezdet · elmaradt · hamarosan · később. A „hamarosan" és az „elmaradt" a SZERVER figyelőjének
// ítélete (`/service-assignments/attention` — ugyanaz a szabály, mint a panelé és a napi levélé), a felület nem
// számol saját nap-határt.
import { DomainBadge } from '@/components/shared/domain-badge';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';
import { DEFAULT_TIME_ZONE, formatDateTime } from '@/lib/format-datetime';
import { useTranslation } from 'react-i18next';

export interface PendingStartBadgeProps {
  /** a sor számlázás-kezdete (eseti díjnál a „Számlázás dátuma") — `null` = nincs megadva */
  billingStartDate: string | null;
  /** a figyelő tétele, ha a sor benne van (`daysUntilStart` < 0 = elmaradt) */
  attention?: { daysUntilStart: number } | undefined;
  /** csak az évszám nélküli dátum (a mobil kártya-fejléc — ott a teljes jelvény a címet szorítaná ki) */
  compact?: boolean;
}

export function PendingStartBadge({
  billingStartDate,
  attention,
  compact = false,
}: PendingStartBadgeProps): JSX.Element {
  const { t, i18n } = useTranslation();
  const fmt = (opts: Intl.DateTimeFormatOptions): string =>
    billingStartDate === null
      ? ''
      : formatDateTime(billingStartDate, i18n.language, DEFAULT_TIME_ZONE, opts);
  const date = fmt({ dateStyle: 'short' });
  const shortDate = fmt({ month: '2-digit', day: '2-digit' });
  const value =
    billingStartDate === null
      ? 'pending_start_missing'
      : attention === undefined
        ? 'pending_start'
        : attention.daysUntilStart < 0
          ? 'pending_start_overdue'
          : 'pending_start_soon';
  const key = {
    pending_start_missing: 'missing',
    pending_start: 'later',
    pending_start_soon: 'soon',
    pending_start_overdue: 'overdue',
  }[value];

  // a DÁTUM a felirat része (user-döntés: a jelvény alatti külön sor csúnya volt) — a hosszabb jelvényhez a
  // lista státusz-oszlopa szélesebb. 1024–1279 px között (oldalsávval) a teljes dátum így sem fér el (mérve:
  // ~180 px jelvény, ~150 px cella), ott évszám nélküli változat áll; a teljes dátum a többi szélességen
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span>
          {!compact && (
            <DomainBadge
              kind="marker"
              value={value}
              label={t(`serviceAssignments.attention.startBadge.${key}`, { date })}
              className="lg:max-xl:hidden"
            />
          )}
          <DomainBadge
            kind="marker"
            value={value}
            label={t(`serviceAssignments.attention.startBadge.${key}`, { date: shortDate })}
            className={compact ? undefined : 'hidden lg:max-xl:inline-flex'}
          />
        </span>
      </TooltipTrigger>
      <TooltipContent>{t(`serviceAssignments.attention.startTooltip.${key}`)}</TooltipContent>
    </Tooltip>
  );
}
